import VendorList from "../../slices/purchase/vendor/VendorList";
import VendorDetails from "../../slices/purchase/vendor/VendorDetails";

const purchaseReducer = {
    vendorList: VendorList,
    vendorDetails: VendorDetails,
};

export default purchaseReducer;